import { PageHero } from '@/components/PageHero'
import { company } from '@/config/company'
import { getBoardUrl } from '@/utils/appBase'
import styles from './ContentPage.module.css'

export function ContactPage() {
  return (
    <>
      <PageHero title="İletişim" subtitle={company.legalName} />
      <section className={styles.section}>
        <div className={`container ${styles.contactGrid}`}>
          <div className={styles.prose}>
            <p className={styles.brandName}>{company.name}</p>
            <h2 className={styles.legalTitle}>{company.legalName}</h2>
            <p>{company.address}</p>
            <p>
              <strong>Telefon:</strong>{' '}
              <a href={`tel:${company.phoneTel}`}>{company.phone}</a>
            </p>
            <p>
              <strong>E-posta:</strong>{' '}
              <a href={`mailto:${company.email}`}>{company.email}</a>
            </p>
            <p>
              <strong>Vergi Dairesi / No:</strong> {company.taxOffice} / {company.taxId}
            </p>
            <p>
              <strong>Çalışma saatleri:</strong> {company.workingHours}
            </p>
            <div className={styles.actions}>
              <a className={styles.btn} href={company.googleMapsUrl} target="_blank" rel="noreferrer">
                Yol Tarifi
              </a>
              <a className={styles.btnGhost} href={getBoardUrl()}>
                Canlı Pano
              </a>
            </div>
          </div>
          <div className={styles.mapWrap}>
            <iframe
              title={`${company.legalName} konum`}
              src={company.googleMapsEmbed}
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
      </section>
    </>
  )
}
